// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","accent":"#BFD730","primary":"#492172","bubble":"UJdS","section":"_26qQ"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/BubbleTitle/BubbleTitle.scss
// module id = 7lW9
// module chunks = 0